import { ArrowIcon } from "@images/svgIcons/arrowIcon"
import { word } from "@modules/core/utils/i18n"
import { SessionBlockFormikType } from "@modules/sessionBlock/sessionBlockFormikTypes"
import { SessionBlock, SessionBlockType } from "@modules/sessionBlock/sessionBlockTypes"
import { useCallback, useMemo } from "react"
import { useTheme } from "styled-components"

export const useBlockDuration = (sessionBlocks?: SessionBlock[] | SessionBlockFormikType[]) => {
  const theme = useTheme()

  const timedBlocks = useMemo(() => {
    return (
      sessionBlocks?.filter(
        (block) =>
          (block.type === SessionBlockType.COACH_NOTE || block.type === SessionBlockType.SESSION_EXERCISE) &&
          !!block.content.durationInMin,
      ) ?? []
    )
  }, [sessionBlocks])

  const timedBlocksTotal = useMemo(() => {
    return timedBlocks.reduce(
      (acc, block) => acc + ("durationInMin" in block.content ? block.content.durationInMin ?? 0 : 0),
      0,
    )
  }, [timedBlocks])

  const getBlockDurationInterval = useCallback(
    (blockIndex: number) => {
      if (!sessionBlocks) return ""
      const block = sessionBlocks[blockIndex]

      if (block.type !== SessionBlockType.COACH_NOTE && block.type !== SessionBlockType.SESSION_EXERCISE) return ""
      if (!block.content.durationInMin) return ""

      const starting = sessionBlocks
        .filter((_, i) => i < blockIndex)
        .filter((b) => b.type === SessionBlockType.COACH_NOTE || b.type === SessionBlockType.SESSION_EXERCISE)
        .reduce((acc, b) => acc + ("durationInMin" in b.content ? b.content.durationInMin ?? 0 : 0), 0)
      const ending = starting + (block.content.durationInMin ?? 0)
      return (
        <>
          {`${word("global.minute.label", { count: 1 })} ${starting} `}
          <ArrowIcon arrowDirection="right" color={theme.neutralColor900} width={14} height={14} arrowType="thin" />
          {` ${word("global.minute.label", { count: 1 })} ${ending}`}
        </>
      )
    },
    [sessionBlocks],
  )

  return { getBlockDurationInterval, timedBlocks, timedBlocksTotal }
}
